'use strict';

import React, { Component, Fragment } from 'react';
import is from 'is_js';
import uniqid from 'uniqid';
import TextInput from 'Components/Forms/Elements/TextInput';
import FileInput from 'Components/Forms/Elements/FileInput';
import TextEditor from 'Components/Forms/Elements/TextEditor';
import Select from 'Components/Forms/Elements/Select';
import MultiSelect from 'Components/Forms/Elements/MultiSelect';
import Switch from 'Components/Forms/Elements/Switch';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import DeleteIcon from '@material-ui/icons/Delete';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import handleChange from 'Components/Forms/Functions/handleChange';
import handleFileChange from 'Components/Forms/Functions/handleFileChange';
import getStateFromObject from 'Components/Forms/Functions/getStateFromObject';
import getFormData from 'Components/Forms/Functions/getFormData';
import { service_units, service_VATs, coworking_place_types } from 'Shared/options';
import bemit from 'Functions/bemit';
import Loader from 'Pure/Loader';
import { isFalse, isTrue, formatNum, num, getBookingServiceRowPrices } from 'Shared/utilities';
import { action } from 'Shared/Routes';
const {
  app,
  qwest
} = window;
const tva_options_sliced = service_VATs.slice(0, -1);
const hours = Array.from({
  length: 25
}).map(function (_v, i) {
  return {
    value: String(i),
    label: (i < 10 ? '0' : '') + i + 'h'
  };
});
const start_hours = hours.slice(0, 24);
const end_hours = hours.slice(1);
export default class ServiceForm extends Component {
  state = {
    status_messages: {},
    selectable_spaces: [],
    servicetitles: [],
    spaces: [],
    'service[open_range_start]': '0',
    'service[open_range_end]': '24',
    'service[spaces]': [],
    'service[multiple_prices]': [],
    'service[etablishment_id]': app.state.session.user?.etablishment,
    loading: true,
    fetched: false
  };
  service_fetched = true;
  spaces_fetched = false;
  titles_fetched = false;
  handleChange = handleChange.bind(this);
  handleFileChange = handleFileChange.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.type === 'update') {
      component.service_fetched = false;
    }
    component.fetchSpaces();
    component.fetchServiceTitle();
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    const prev_title = prev_state['service[title]'];
    if (prev_title !== state['service[title]']) {
      component.handleServiceTitleChange();
    }
  }
  isReady = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const is__ready = [component.service_fetched, component.spaces_fetched, component.titles_fetched].every(ready => ready === true);
    return is__ready;
  };
  handleServiceTitleChange = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const servicetitle = state.servicetitles.find(doc => doc.id === state['service[title]']);
    if (!servicetitle) {
      return component.setState({
        selectable_spaces: [],
        'service[spaces]': []
      });
    }
    const allowed_types = servicetitle.types || [];
    component.setState({
      'service[spaces]': state['service[spaces]'].filter(function (id) {
        const space = state.spaces.find(space => space.id === id);
        const type_infos = coworking_place_types.find(opt => opt.value === space?.type);
        return allowed_types.includes(type_infos?.new_value);
      }),
      selectable_spaces: state.spaces.filter(function (space) {
        const type_infos = coworking_place_types.find(opt => opt.value === space.type);
        return allowed_types.includes(type_infos?.new_value);
      }).map(space => ({
        label: space.name,
        value: space.id
      })),
      service_spaces_key: uniqid(),
      servicetitle: servicetitle
    });
  };
  fetchService = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('getAllServices'), {
      id: props.id || document.location.pathname.split('/liste-des-services/')[1],
      include_disabled: true,
      with_count: false
    }).then(function (xhr, response) {
      let {
        images,
        spaces = [],
        multiple_prices = [],
        ...service
      } = response.data?.[0] || {};
      images = (images || []).map(image => ({
        ...image,
        status: 'uploaded'
      }));
      const update = getStateFromObject({
        data: service,
        model: 'service'
      });
      const state_update = {
        ...update,
        'service[images]': images,
        '__files-service[images]': images,
        'service[spaces]': spaces,
        'service[multiple_prices]': multiple_prices,
        spaces_key: uniqid()
      };
      component.service_fetched = true;
      if (component.isReady()) {
        state_update.loading = false;
        state_update.fetched = true;
      }
      component.setState(state_update);
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  fetchServiceTitle = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/servicetitle/get-all').then(function (xhr, response) {
      const state_update = {
        servicetitles: response.data || [],
        service_titles_key: uniqid()
      };
      component.titles_fetched = true;
      if (component.isReady()) {
        state_update.loading = false;
        state_update.fetched = true;
      }
      component.setState(state_update);
      if (props.type === 'update' && component.spaces_fetched) {
        component.fetchService();
      }
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  fetchSpaces = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/coworking-space/get-all', {
      etablishment_id: app.state.session.user?.etablishment,
      with_count: false
    }).then(function (xhr, response) {
      const state_update = {
        spaces: response.data || []
      };
      component.spaces_fetched = true;
      if (component.isReady()) {
        state_update.loading = false;
        state_update.fetched = true;
      }
      component.setState(state_update);
      if (props.type === 'update' && component.titles_fetched) {
        component.fetchService();
      }
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const service = getFormData({
      state: state,
      pattern: 'service['
    });
    const url = props.type === 'update' ? '/service/update' : '/service/create';
    delete service._servicetitle;
    qwest.post(url, service).then(function (xhr, response) {
      if (props.type === 'update') {
        component.fetchService();
      } else {
        component.clearForm();
        window.setTimeout(function () {
          app.navigateTo('/liste-des-services');
        }, 2000);
      }
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  clearForm = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const update = Object.keys(state).filter(key => key.startsWith('service[')).reduce(function (update, key) {
      if (key === 'service[spacetype]') return update;
      if (is.string(state[key])) {
        update[key] = '';
      } else if (is.array(state[key])) {
        update[key] = [];
      } else if (is.json(state[key])) {
        update[key] = {};
      }
      return update;
    }, {});
    component.setState(update);
  };
  addPrice = () => {
    const component = this,
      props = this.props,
      state = this.state;
    let id = uniqid();
    let prices = state['service[multiple_prices]'];
    prices.push({
      amount: '',
      tva: '',
      id: id
    });
    component.setState({
      'service[multiple_prices]': prices
    });
  };
  deletePrice = price_id => {
    const component = this,
      props = this.props,
      state = this.state;
    const multiple_prices_filtered = state['service[multiple_prices]'].filter(price => price['id'] !== price_id);
    component.setState({
      'service[multiple_prices]': multiple_prices_filtered
    });
  };
  handlePriceChange = ({
    e,
    value,
    name,
    id,
    field_name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let multiple_prices = state['service[multiple_prices]'].slice(0);
    const price_index = multiple_prices.map(price => price.id).indexOf(id);
    multiple_prices[price_index][field_name] = value;
    component.setState({
      multiple_prices: multiple_prices
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = getFormStatus(state);
    const servicetitle_options = (state.servicetitles || []).map(function (data) {
      let option = {
        value: data.id,
        label: data.title
      };
      return option;
    });
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    const fetcher = state.loading === true && !component.isReady() ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['primary', 'bg-white']
    }) : undefined;
    const multiple_prices = state["service[multiple_prices]"].map(function (price, index) {
      let output = /*#__PURE__*/React.createElement(Grid, {
        key: price.id,
        container: true,
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 3
      }, /*#__PURE__*/React.createElement(TextInput, {
        onChange: ({
          e,
          value,
          name
        }) => component.handlePriceChange({
          e,
          name,
          value,
          id: price.id,
          field_name: 'amount'
        }),
        value: String(price.amount || ''),
        name: 'service[multiple_prices][' + index + '][amount]',
        type: "text",
        label: "Montant HT",
        "allow-negative": false,
        digits: 2,
        "safe-value": true,
        status: state.status_messages
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 3
      }, /*#__PURE__*/React.createElement(Select, {
        onChange: ({
          e,
          value,
          name
        }) => component.handlePriceChange({
          e,
          name,
          value,
          id: price.id,
          field_name: 'tva'
        }),
        value: String(price.tva || ''),
        name: 'service[multiple_prices][' + index + '][tva]',
        options: tva_options_sliced,
        "default-value": tva_options_sliced[0]?.value,
        type: "text",
        label: "TVA",
        status: state.status_messages
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 3,
        className: "u-flex u-center"
      }, /*#__PURE__*/React.createElement("strong", null, formatNum(num(num(price.amount) * num(price.tva, 0) || 1)), '€', "\xA0TTC")), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 3,
        className: "u-flex u-center"
      }, /*#__PURE__*/React.createElement(Button, {
        color: "primary",
        variant: "contained",
        size: "large",
        onClick: e => component.deletePrice(price.id)
      }, /*#__PURE__*/React.createElement(DeleteIcon, null))));
      return output;
    });
    const prices = getBookingServiceRowPrices({
      start: '10',
      end: '11',
      hours_count: 1,
      quantity: 1,
      service: {
        unit: state['service[unit]'],
        tva_type: state['service[tva_type]'],
        simple_price: state['service[simple_price]'],
        multiple_prices: state['service[multiple_prices]']
      }
    });
    const fields = props.type !== 'update' || state.fetched ? /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(Switch, {
      onChange: component.handleChange,
      value: !isFalse(state["service[enabled]"]),
      name: "service[enabled]",
      "top-label": "Statut",
      label: "Activ\xE9",
      "left-label": "D\xE9sactiv\xE9",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 8
    }, /*#__PURE__*/React.createElement(Select, {
      options: servicetitle_options,
      onChange: component.handleChange,
      value: state['service[title]'],
      name: "service[title]",
      type: "text",
      label: "Titre *",
      key: state.service_titles_key,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(MultiSelect, {
      options: state.selectable_spaces,
      onChange: component.handleChange,
      value: state['service[spaces]'],
      name: "service[spaces]",
      type: "text",
      label: "Espaces",
      "read-only": !state['service[title]'],
      status: state.status_messages,
      key: state.service_spaces_key
    })), isTrue(state.servicetitle?.with_stock) ? /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['service[daily_stock]'],
      name: "service[daily_stock]",
      type: "text",
      "allow-negative": false,
      "safe-value": true,
      int: true,
      label: "Nombre de places par jour",
      status: state.status_messages
    })) : undefined, isTrue(state.servicetitle?.with_range) ? /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(Select, {
      options: start_hours,
      onChange: component.handleChange,
      value: state['service[open_range_start]'],
      name: "service[open_range_start]",
      label: "Plage horaire - d\xE9but",
      status: state.status_messages
    })) : undefined, isTrue(state.servicetitle?.with_range) ? /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(Select, {
      options: end_hours,
      onChange: component.handleChange,
      value: state['service[open_range_end]'],
      name: "service[open_range_end]",
      label: "Plage horaire - fin",
      status: state.status_messages
    })) : undefined, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12
    }, /*#__PURE__*/React.createElement(TextEditor, {
      onChange: component.handleChange,
      value: state["service[description]"] || '',
      name: "service[description]",
      label: "Description",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/React.createElement(FileInput, {
      accept: ".jpg,.jpeg,.png,.gif",
      onChange: component.handleFileChange,
      name: "service[images]",
      data: state,
      status: state.status_messages,
      label: "Photo(s)"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(Select, {
      options: service_units,
      defaultValue: service_units?.[0]?.value,
      onChange: component.handleChange,
      value: state['service[unit]'] || '',
      name: "service[unit]",
      type: "text",
      label: "R\xE9servable \xE0 *",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12
    }, /*#__PURE__*/React.createElement(Select, {
      options: service_VATs,
      defaultValue: service_VATs[0]?.value,
      onChange: component.handleChange,
      value: state['service[tva_type]'] || '',
      name: "service[tva_type]",
      type: "text",
      label: "TVA",
      status: state.status_messages
    })), state['service[tva_type]'] !== "multiple" ? /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['service[simple_price]'],
      name: "service[simple_price]",
      type: "text",
      "allow-negative": false,
      digits: 2,
      "safe-value": true,
      label: "Montant HT",
      status: state.status_messages
    })) : /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12,
      className: "u-flex u-items-center u-flex-gap-15\r u-flex-wrap"
    }, multiple_prices, /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      variant: "contained",
      size: "large",
      className: "u-margin-20",
      onClick: component.addPrice
    }, "Ajouter un montant")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: String(prices.total_price),
      name: "total_price",
      type: "text",
      "read-only": true,
      label: "Total TTC"
    }))) : undefined;
    let output = /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("form", {
      method: "POST",
      action: "/service/create",
      className: props.paper !== false ? 'c-paper' : undefined
    }, fields, status, fetcher), /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-text-center\r u-margin-top-25 u-padding-bottom-20 "
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']),
      onClick: component.validate
    }, props.type === 'update' ? 'Mettre à jour' : 'Créer ce service', loader)));
    return output;
  }
}
